export default {
  name: 'cases'
};